module.exports = __webpack_public_path__ + "img/cn.3a5b5ac1.svg";